import template from './user_permission_report.all.html';
import controller from './user_permission_report.all.controller';
import './user_permission_report.all.scss';

let userPermissionReportAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template,
    controller
};

export default userPermissionReportAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/user_permission_report/all/user_permission_report.all.component.js